import {
  Divider,
  Grid,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import React, { Fragment } from "react";
import yoozIt_img from "../../../../assets/images/home_content_1.png";
import topUp_img from "../../../../assets/images/home_content_2.png";
import billPay_img from "../../../../assets/images/home_content_3.png";
import getpPaid_img from "../../../../assets/images/home_content_4.png";
import signUp_img from "../../../../assets/images/home_content_5.png";
import yoozIt_logo from "../../../../assets/images/yoozit.png";
import TextList from "../../components/TextList";
import HomeHeader from "./header";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTabPosition } from "../../uiSlice";

const useStyles = makeStyles((theme) => ({
  headingTitle: {
    fontFamily: "Akzidenz-Grotesk BQ, serif",
  },
  content: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.up("lg")]: {
      marginLeft: "5%",
    },
  },

  negativeMargin: {
    marginTop: -12,
  },
  signUpContainer: {
    background: "#F2F2F2",
    margin: "auto",
    paddingTop: 20,
  },
  root: {
    margin: "auto",
    marginTop: 20,
    marginBottom: 20,
    // textAlign: "center",
  },
  link: {
    color: theme.palette.secondary.main,
    fontFamily: "Akzidenz-Grotesk BQ, serif",
  },
  img: {
    width: "100%",
  },
  linktext: {
    color: theme.palette.primary.light,
    "&:hover": { color: `${theme.palette.primary.main} !important` },
  },
}));

export default function ContentSection() {
  const classes = useStyles();
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("xs"));
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();

  const LinkText = (props) => {
    const { navIndex, route, text } = props;
    return (
      <Link
        onClick={() => {
          window.scrollTo(0, 0);
          dispatch(setTabPosition(navIndex));
        }}
        component={RouterLink}
        to={route}
        // color="primary"
        className={classes.linktext}
      >
        <b>{text}</b>
      </Link>
    );
  };
  return (
    <Fragment>
      <div className={classes.root}>
        <HomeHeader
          path="/quickpay"
          tabPosition={0}
          special={
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <img
                  alt="yooz it logo"
                  src={yoozIt_logo}
                  width={xs ? 200 : sm ? 200 : 380}
                  height="100%"
                  className={classes.img}
                />
              </Grid>
            </Grid>
          }
          list={
            <TextList
              items={[
                <span>
                  <b>YOOZ</b>&nbsp;It to pay bills!
                  <br />
                  <b>YOOZ</b>&nbsp;It to top up!
                  <br />
                  <b>YOOZ</b>&nbsp;It to get paid!
                  <br />
                </span>,
                <span>
                  It's convenient, safe and easy! <br />
                  No apps! No lines! No problems!
                </span>,
              ]}
            />
          }
          img={yoozIt_img}
        />
        {xs && <Divider variant="middle" />}

        <HomeHeader
          tabPosition={1}
          title="PAY BILLS"
          path="/billpay"
          color="#FF7E00"
          titleSm="h2"
          titleLg="h1"
          titleXs="h3"
          imgPosition="left"
          list={
            <TextList
              items={[
                <span>Make payments... anywhere, anytime!</span>,
                <span>
                  <LinkText navIndex={7} route="/quickpay" text="Quick Pay" />{" "}
                  No need to sign up... just pay!
                </span>,
                <span>
                  <LinkText navIndex={2} route="/billpay" text="YOOZ Scan2Pay"/>{" "}
                   – The Safe, Easy, Contactless Way to PAY for your favourite goods and services.
                </span>,
                <span>
                  <LinkText navIndex={8} route="/signup" text="Online Signup" />{" "}
                  for FREE so you can <b>YOOZ</b> It anywhere, anytime!
                </span>,
                <span>
                  <LinkText navIndex={6} route="/contact" text="YOOZ Mobile" />{" "}
                  No WiFi? No Data? No Problem!  Pay your bills from your phone.{" "}
                  <LinkText navIndex={6} route="/contact" text="Call or Email us" />{" "}
                  to Register. When registered simply dial *190# for FREE and pay your bills anytime, anywhere. 
                </span>,
              ]}
            />
          }
          img={billPay_img}
        />
        {xs && <Divider variant="middle" />}
        <HomeHeader
          tabPosition={2}
          title="Top Up!"
          path="/topup"
          color="#3A75BA"
          titleSm="h2"
          titleLg="h1"
          titleXs="h3"
          imgPosition="right"
          list={
            <TextList
              items={[
                <span>Top up any prepaid phone... anywhere, anytime!</span>,
                <span>
                  <LinkText
                    navIndex={7}
                    route="/quicktopup"
                    text="Quick Pay"
                  />{" "}
                  Top Up yours or someone else's!
                </span>,
                <span>
                  Use your mobile phone to Top Up any prepaid phone on the same network.{" "}
                  <LinkText navIndex={6} route="/contact" text="Call or Email us" />{" "}
                  to Register.  Once registered simply dial *190# for FREE to Top Up.
                </span>,
              ]}
            />
          }
          img={topUp_img}
        />
        {xs && <Divider variant="middle" />}

        <HomeHeader
          tabPosition={3}
          path="/partners"
          title="Get Paid!"
          color="#F7517B"
          titleSm="h2"
          titleLg="h1"
          titleXs="h3"
          imgPosition="left"
          list={
            <TextList
              items={[
                <span>
                  Expand the earning potential of your business with YOOZ.  Collect payments securely, quickly and easily through various channels.
                 </span>,
                <span>
                  Want to close that sale even faster? Then{" "}
                  
                  <LinkText navIndex={2} route="/scan2pay" text="YOOZ Scan2Pay"/>{" "} is just what your business needs.  Revolutionise your in-store point of sale with contactless payments or move your business online by sharing a URL payment link.  
                  With{" "}<LinkText navIndex={2} route="/scan2pay" text="YOOZ Scan2Pay"/>{" "}you can say goodbye to payment delays and hello to instant online payments.
                </span>
              ]}
            />
          }
          img={getpPaid_img}
        />
      </div>
      <div className={classes.signUpContainer}>
        <HomeHeader
          path="/signup"
          title={"Sign Up!"}
          color={theme.palette.secondary.main}
          titleSm="h2"
          titleLg="h1"
          titleXs="h3"
          list={
            <TextList
              items={[
                <span>
                  Sign up to access &nbsp;<b>YOOZ</b>&nbsp; from your mobile
                  device using your credit card and mobile number.
                </span>,
              ]}
            />
          }
          img={signUp_img}
        />
      </div>
    </Fragment>
  );
}
